import { Injectable } from '@angular/core';

@Injectable()
export class ConsequenceAxisLabelService {
  private readonly charCodeA: number;
  private readonly len: number;

  constructor() {
    this.charCodeA = 'a'.charCodeAt(0);
    this.len = 'z'.charCodeAt(0) - this.charCodeA + 1;
  }

  getLetterBasedLabel(index: number) {
    let label = '';

    while (index >= 0) {
      label = String.fromCharCode(index % this.len + this.charCodeA).toUpperCase() + label;
      index = Math.floor(index / this.len) - 1;
    }

    return label;
  }
}
